import { render, staticRenderFns } from "./task-generator.vue?vue&type=template&id=0b937205&"
import script from "./task-generator.vue?vue&type=script&lang=ts&"
export * from "./task-generator.vue?vue&type=script&lang=ts&"
import style0 from "./task-generator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports